import { Link } from "react-router-dom";
import Highlight from "@/components/base/Highlight";

interface ArticleCardProps {
  to: string;
  title: string;
  cover?: string;
  badge?: string;
  meta: string;
  summary: string;
  tags?: string[];
  query?: string;
  rating?: number;
}

export default function ArticleCard({
  to,
  title,
  cover,
  badge,
  meta,
  summary,
  tags = [],
  query,
  rating,
}: ArticleCardProps) {
  return (
    <Link
      to={to}
      className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition duration-300 hover:-translate-y-1 hover:border-primary-300 sm:flex-row"
    >
      {cover && (
        <div className="relative h-48 w-full shrink-0 overflow-hidden bg-background-200 sm:h-auto sm:w-52">
          <img
            src={cover}
            alt={title}
            title={`${title} 小黄人电影 资讯`}
            className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
          />
        </div>
      )}
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
          {badge && (
            <span className="rounded-full bg-primary-100 px-2.5 py-0.5 font-medium text-primary-800">
              {badge}
            </span>
          )}
          <span>{meta}</span>
        </div>
        <h3 className="mt-2 text-base font-bold leading-snug text-foreground-950 transition group-hover:text-primary-700 md:text-lg">
          <Highlight text={title} query={query} />
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">
          <Highlight text={summary} query={query} />
        </p>
        <div className="mt-3 flex flex-wrap items-center gap-2">
          {typeof rating === "number" && (
            <span className="flex items-center gap-1 rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-semibold text-accent-800">
              <i className="ri-star-fill"></i>
              {rating} 分
            </span>
          )}
          {tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] text-secondary-800"
            >
              #{tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}